module.exports = __webpack_public_path__ + "img/scatter-chart-svgrepo-com.fd0801f6.svg";